module.exports = __webpack_public_path__ + "img/1.04a47b4b.png";